export default {
  getQuickEditStatus(state) {
    return state.quickEditActive;
  },
  getImportedVendors(state) {
    return state.importedVendors;
  },
};
